export const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
    fontWeight: "700",
  };
  
  export const labelStyle = {
    fontWeight: "800",
    fontSize: "18px",
  };
  
  export const textStyle ={
    fontSize:'12px',
    paddingBottom:'1rem'
  }
  
  export const buttonStyle = {
    height: "2.5rem",
    lineHeight: "2.2rem",
    backgroundColor: "#2b2f89",
    color: "#fff",
    fontWeight: "600",
    padding: "0 23px",
    display: "inline-block",
    textAlign: "center",
    width: "150px",
    borderRadius: "4px",
    textTransform: "uppercase",
  };
  
  export const formSubmissionErrorStyle = {
    backgroundColor: "#f1c40f",
    color: "#000",
    fontSize: "25px",
    fontWeight: "800",
    borderRadius: "4px",
    padding: "2rem 1rem",
    letterSpacing: "1px",
    textAlign: "center",
    marginBotton: "1.5rem",
  };
  
  export const stepStyle ={
    marginBottom:'1rem',
    width:'50%',
    borderBottom:'3px solid #2b2f89',
    fontSize:'10px',
    paddingTop:'1rem'}
  
  export const stepStyle2={
    marginBottom:'2rem',
    width:'100%',
    borderBottom:'3px solid #2b2f89',
    fontSize:'10px',
    paddingTop:'1rem'
  }